import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import PageMetaLoader from '../components/PageMetaLoader';
const AboutUsPage = () => {
  const teamMembers = [
    {
      name: 'CHEAM Savun',
      position: 'CTO (Consultant)',
      bio: 'Over 20 years working in IT and Software development'
    },
    // {
    //   name: 'Sales & Marketing',
    //   position: 'LeadSales & Marketing',
    //   bio: 'On vacant'
    // },
    // {
    //   name: 'Lead Support',
    //   position: 'Lead Support',
    //   bio: 'On vacant'
    // },
  ];

  const values = [
    {
      title: 'Innovation',
      description: 'We continuously evolve our solutions with the latest technologies to meet the changing needs of businesses.'
    },
    {
      title: 'Reliability',
      description: 'Our secure, stable cloud infrastructure ensures your business data is always accessible and protected.'
    },
    {
      title: 'Local Expertise',
      description: 'Designed specifically for Cambodian businesses, our solutions address local market challenges and compliance requirements.'
    },
    {
      title: 'Client Success',
      description: 'We measure our success by the success of our clients, providing ongoing support and training to maximize ROI.'
    }
  ];

  return (
    <AboutContainer>
      <PageMetaLoader pageUrl="about-us" />
      <HeroSection>
        <HeroContent>
          <h1>About AKAS</h1>
          <p>
            AKAS is Cambodia's leading provider of cloud-based business ERPsolutions, helping organizations of all sizes streamline operations, increase efficiency, and drive growth through innovative software.
          </p>
        </HeroContent>
      </HeroSection>

      <MissionSection>
        <h2>Our Mission</h2>
        <p>
          To empower businesses with accessible, innovative cloud solutions that drive efficiency, growth, and digital transformation.
        </p>
      </MissionSection>

      <StorySection>
        <SectionTitle>Our Story</SectionTitle>
        <StoryContent>
          <p>
            Founded in 2024, AKAS was established to address the growing need for affordable, locally-supported business management solutions in Cambodia. Recognizing that many Cambodian businesses were underserved by expensive international software or limited by basic spreadsheet solutions, we developed a modular platform specifically tailored to the local market.
          </p>
          <p>
            Starting with our core HRMS module, we've since expanded our offering to include comprehensive solutions for CRM, sales management, purchasing, accounting, and more. Today, AKAS serves businesses across Cambodia, from small enterprises to large corporations, helping them streamline operations and leverage the power of cloud technology.
          </p>
        </StoryContent>
      </StorySection>

      <ValuesSection>
        <SectionTitle>Our Values</SectionTitle>
        <ValuesGrid>
          {values.map((value, index) => (
            <ValueCard key={index}>
              <h3>{value.title}</h3>
              <ValueDescription>{value.description}</ValueDescription>
            </ValueCard>
          ))}
        </ValuesGrid>
      </ValuesSection>

      {/* <TeamSection>
        <SectionTitle>Our Team</SectionTitle>
        <p className="team-intro">
          Led by experienced software developers and business consultants, our team combines technical expertise with deep understanding of Cambodian business needs.
        </p>
        <TeamGrid>
          {teamMembers.map((member, index) => (
            <TeamMemberCard key={index}>
              <TeamMemberAvatar>
                {member.name.split(' ')[0][0]}{member.name.split(' ')[1][0]}
              </TeamMemberAvatar>
              <TeamMemberInfo>
                <h3>{member.name}</h3>
                <h4>{member.position}</h4>
                <p>{member.bio}</p>
              </TeamMemberInfo>
            </TeamMemberCard>
          ))}
        </TeamGrid>
      </TeamSection> */}

      <CTASection>
        <h2>Ready to transform your business?</h2>
        <p>Contact us today to learn how AKAS solutions can help your organization thrive.</p>
        <CTAButton to="/contact">Contact Us</CTAButton>
      </CTASection>
    </AboutContainer>
  );
};

const AboutContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem 4rem;
`;

const HeroSection = styled.section`
  position: relative;
  padding: 4rem 2rem;
  margin-bottom: 3rem;
  border-radius: 10px;
  background-color: var(--primary-light);
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/images/about/about-hero.jpeg');
    background-size: cover;
    background-position: center;
    opacity: 0.15;
    z-index: 0;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  
  h1 {
    font-size: 3rem;
    margin-bottom: 1.5rem;
    color: var(--primary-color);
  }
  
  p {
    font-size: 1.25rem;
    line-height: 1.6;
    color: var(--text-dark);
  }
`;

const MissionSection = styled.section`
  background-color: var(--primary-color);
  color: white;
  padding: 3rem 2rem;
  text-align: center;
  border-radius: 10px;
  margin-bottom: 4rem;
  
  h2 {
    font-size: 2.2rem;
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 1.2rem;
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.2rem;
  color: var(--primary-color);
  margin-bottom: 2rem;
  text-align: center;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 80px;
    height: 3px;
    background-color: var(--accent-color);
    margin: 1rem auto 0;
    border-radius: 2px;
  }
`;

const StorySection = styled.section`
  margin-bottom: 4rem;
`;

const StoryContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  
  p {
    font-size: 1.1rem;
    line-height: 1.8;
    margin-bottom: 1.5rem;
    color: var(--text-color);
  }
`;

const ValuesSection = styled.section`
  margin-bottom: 4rem;
`;

const ValueDescription = styled.div`
  color: var(--text-color);
  margin-bottom: 1.5rem;
`;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
`;

const ValueCard = styled.div`
  background-color: var(--primary-light);
  padding: 2rem;
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: var(--primary-color);
  }
  
  p {
    color: var(--text-dark);
    line-height: 1.6;
  }
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

const TeamSection = styled.section`
  margin-bottom: 4rem;
  
  .team-intro {
    text-align: center;
    max-width: 800px;
    margin: 0 auto 3rem;
    font-size: 1.1rem;
    line-height: 1.6;
    color: var(--text-dark);
  }
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  justify-items: center;
  max-width: 600px;
  margin: 0 auto;
`;

const TeamMemberCard = styled.div`
  display: flex;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

const TeamMemberAvatar = styled.div`
  width: 80px;
  height: 80px;
  background-color: var(--primary-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: bold;
  flex-shrink: 0;
`;

const TeamMemberInfo = styled.div`
  padding: 1.5rem;
  
  h3 {
    font-size: 1.3rem;
    margin: 0 0 0.5rem;
    color: var(--primary-color);
  }
  
  h4 {
    font-size: 1rem;
    margin: 0 0 1rem;
    color: var(--accent-color);
    font-weight: 500;
  }
  
  p {
    margin: 0;
    font-size: 0.95rem;
    line-height: 1.6;
    color: var(--text-dark);
  }
`;

const CTASection = styled.div`
  background-color: var(--primary-color);
  color: white;
  padding: 3rem;
  text-align: center;
  border-radius: 10px;
  
  h2 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 1.1rem;
    margin-bottom: 2rem;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const CTAButton = styled(Link)`
  display: inline-block;
  padding: 0.75rem 2rem;
  background-color: white;
  color: var(--primary-color);
  font-weight: 500;
  border-radius: 40px;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
`;

export default AboutUsPage; 